var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-module-ach-container"},[_c('ach-item',{attrs:{"data":_vm.paymentData}}),_c('div',{staticClass:"payment-module-ach-container__link",on:{"click":function($event){return _vm.$emit('changeSavedPayment', 'braintree_ach')}}},[_vm._v(" Change ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }